import { useEffect, useState } from "react";
import { adminApi } from "../api";

export default function AdminAudit() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  useEffect(() => {
    adminApi.auditLog(200)
      .then((r) => setItems(r.data || []))
      .catch((e) => setErr(e.message || "Erro"))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="admin-audit-page">
      <h1 className="text-2xl font-bold mb-5" style={{ fontFamily: "'Fraunces', serif" }}>Log de Auditoria</h1>
      {err && <div className="mb-3 px-3 py-2 bg-red-50 border border-red-200 text-sm text-red-700 rounded">{err}</div>}
      {loading ? <div className="text-sm text-[#4B5563]">A carregar...</div> : (
        <div className="bg-white border border-[#E6E1D6] rounded overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-[#F5F2EB] border-b border-[#E6E1D6]">
              <tr>
                <th className="text-left px-3 py-2 text-[10px] uppercase tracking-[0.15em] text-[#978D78]">Data</th>
                <th className="text-left px-3 py-2 text-[10px] uppercase tracking-[0.15em] text-[#978D78]">Utilizador</th>
                <th className="text-left px-3 py-2 text-[10px] uppercase tracking-[0.15em] text-[#978D78]">Tabela</th>
                <th className="text-left px-3 py-2 text-[10px] uppercase tracking-[0.15em] text-[#978D78]">Op</th>
                <th className="text-left px-3 py-2 text-[10px] uppercase tracking-[0.15em] text-[#978D78]">PK</th>
                <th className="text-left px-3 py-2 text-[10px] uppercase tracking-[0.15em] text-[#978D78]">Alterações</th>
              </tr>
            </thead>
            <tbody>
              {items.length === 0 && <tr><td colSpan={6} className="text-center py-8 text-[#6B7280]">Sem eventos.</td></tr>}
              {items.map((r, i) => (
                <tr key={`audit-${r.at || i}`} className="border-b border-[#F3F0E7] align-top">
                  <td className="px-3 py-2 text-xs font-mono text-[#4B5563] whitespace-nowrap">{(r.at || "").replace("T", " ").slice(0, 19)}</td>
                  <td className="px-3 py-2 text-xs">{r.email} <span className="text-[#9CA3AF]">#{r.user_id}</span></td>
                  <td className="px-3 py-2 text-xs font-mono">{r.table}</td>
                  <td className="px-3 py-2">
                    <span className={`text-[9px] uppercase tracking-[0.15em] font-semibold px-1.5 py-0.5 rounded border ${r.op === 'update' ? 'bg-blue-50 text-blue-700 border-blue-200' : 'bg-green-50 text-green-700 border-green-200'}`}>
                      {r.op}
                    </span>
                  </td>
                  <td className="px-3 py-2 text-xs font-mono">{r.pk ?? "—"}</td>
                  <td className="px-3 py-2 text-xs text-[#4B5563]">
                    <pre className="font-mono text-[11px] whitespace-pre-wrap max-w-xl overflow-hidden">{JSON.stringify(r.after ?? r.before ?? {}, null, 2)}</pre>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
